<template>
  <div class="statusBox">
    <!-- 提交成功 -->
    <div class="success">
      <i class="el-icon-success" style="font-size: 100px; color: #5FB878;"></i>
      <div class="title">提交成功</div>
    </div>
    <!-- 提交失败 -->
    <div class="fail">
      <i class="el-icon-error" style="font-size: 100px; color: #f5222d;"></i>
      <div class="title">提交失败</div>
    </div>
    <div class="description">请核对并修改以下信息后，再重新提交</div>
    <div class="extra">
      <div class="extra_t">您提交的内容有如下错误：</div>
      <div class="extra_d">
        <i
          class="el-icon-warning"
          style="color: #f5222d; margin-right: 5px"
        ></i>
        您的账户已被冻结
        <a class="extra_a" href="#">立即解冻</a>
      </div>
      <div class="extra_d">
        <i
          class="el-icon-warning"
          style="color: #f5222d; margin-right: 5px"
        ></i>
        您的账户还不具备申请资格
        <a class="extra_a" href="#">立即升级</a>
      </div>
    </div>
    <button class="layui-btn layui-btn-normal">返回修改</button>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.statusBox {
  text-align: center;
  padding: 100px 0 50px;
  background: #fff;
}

.title {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 16px;
}

.description {
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 24px;
}

.extra {
  background: #fafafa;
  padding: 24px 40px;
  border-radius: 2px;
  text-align: left;
  margin: 0 auto 30px;
  width: 60%;
}

.extra_t {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  margin-bottom: 16px;
}

.extra_d {
  font-size: 15px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 16px;
}

.extra_a {
  color: #1890ff;
  margin-left: 10px;
}
</style>
